import { NavLink, Outlet, useLocation } from 'react-router-dom'

import { useAccess } from '../lib/session'

// Drugorzędny pasek podzakładek — renderuje pigułki + <Outlet/> dla tras
// zgrupowanych pod jedną zakładką główną (np. Analiza przeciwnika: Drużyny /
// Zawodnicy / Sezon; Trening: Raport / Wbijanie metryk). Sam pasek jest
// no-print (trasy druku i tak żyją poza shellem). Przy włączonej fladze
// AUTH_REQUIRED pigułki stron bez dostępu znikają (sekcje: lib/access.ts).
export interface SubTab {
  to: string
  label: string
  // Prefiksy uznające podzakładkę za aktywną (domyślnie [to]) — pozwala
  // podświetlić „Drużyny" także na widoku szczegółu /dossier/:id itd.
  prefixes?: string[]
}

export function SubTabLayout({ tabs }: { tabs: SubTab[] }) {
  const { pathname } = useLocation()
  const access = useAccess()
  return (
    <>
      <div className="no-print border-b border-ink-100 bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-1.5 px-6 py-2">
          {tabs.filter((t) => access.canView(t.to)).map((t) => {
            const prefixes = t.prefixes ?? [t.to]
            const active = prefixes.some((p) => pathname === p || pathname.startsWith(p + '/'))
            return (
              <NavLink
                key={t.to}
                to={t.to}
                className={[
                  'rounded-full px-3.5 py-1.5 text-[13px] font-semibold transition-colors',
                  active
                    ? 'bg-forest-800 text-white shadow-sm'
                    : 'text-ink-500 hover:bg-ink-100 hover:text-ink-900',
                ].join(' ')}
              >
                {t.label}
              </NavLink>
            )
          })}
        </div>
      </div>
      <Outlet />
    </>
  )
}
